// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"0":"ed765134","355":"cc680d3b","380":"372c6651","487":"f80cb33a"}[chunkId] + ".js";
};